import React from 'react';
import ReactDOM from 'react-dom/client';
import { setupIonicReact } from '@ionic/react';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import './styles/globals.css';
import { getCachedPageConfig, loadPageConfig } from './services/pageApi';
import { initFirebaseWeb, isFirebaseWebReady, preloadFirebaseAuthPlugin } from './services/firebase';

setupIonicReact({ mode: 'md', animated: true });
defineCustomElements(window);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element missing');

async function bootstrap(): Promise<void> {
  const cached = await getCachedPageConfig();
  if (cached) initFirebaseWeb(cached.FirebaseList.Web);

  if (!isFirebaseWebReady()) {
    try {
      const config = await loadPageConfig();
      initFirebaseWeb(config.FirebaseList.Web);
    } catch {
      /* boot continues */
    }
  }

  await preloadFirebaseAuthPlugin();

  const { App } = await import('./App');
  ReactDOM.createRoot(rootElement as HTMLElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

void bootstrap();
